// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message
import createBatchedReferenceResolver from 'reference-resolvers/lib/createBatchedReferenceResolver';
import { fetchVisitors } from '../clients/fetchVisitors';
import { VISITOR } from '../constants/ResolverKeys';
export default createBatchedReferenceResolver({
  cacheKey: VISITOR,
  fetchByIds: fetchVisitors
});